// ============================================================================
// Steadfastly - Examiner Mode Banner Component
// Shows when in simplified examiner view
// ============================================================================
import React from 'react';
import { Icons } from './Icons';

export function ExaminerModeBanner({ active, onExit, darkMode }) {
  if (!active) return null;
  
  return (
    <div className={`fixed top-0 left-0 right-0 z-40 px-4 py-2 flex items-center justify-between ${
      darkMode ? "bg-amber-900/90 text-amber-100" : "bg-amber-500 text-white"
    }`}>
      <div className="flex items-center gap-2">
        <Icons.Eye className="w-4 h-4" />
        <span className="font-medium text-sm">Examiner Mode Active</span>
        <span className="text-xs opacity-75">— Internal notes and comments are hidden</span>
      </div>
      <button 
        onClick={onExit}
        className={`px-3 py-1 text-sm rounded-lg transition-colors ${
          darkMode ? "bg-amber-800 hover:bg-amber-700" : "bg-amber-600 hover:bg-amber-700"
        }`}
      >
        Exit (Ctrl+E)
      </button>
    </div>
  );
}

export default ExaminerModeBanner;
